import {
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import EventIcon from "@mui/icons-material/Event";
import { useUser } from "../../UserContext";
import SlotPicker from "../../Booking/SlotPicker";

const HomeBrand = () => {
  const navigate = useNavigate();
  const { currentUser } = useUser();

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <SlotPicker />
        </Grid>
        <Grid item xs={4}>
          <Grid container spacing={3}>
            {/* Quick Navigation Cards - Mass Booking moved to first position */}
            <Grid item xs={12}>
              <Card
                sx={{
                  height: "100%",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    transition: "transform 0.2s",
                  },
                }}
                onClick={() => navigate("/mass-bookings")}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <RocketLaunchIcon
                      sx={{ fontSize: 40, color: "primary.main", mr: 2 }}
                    />
                    <Typography variant="h6">Mass Booking Tool</Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    Book multiple events at once using our mass booking feature
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card
                sx={{
                  height: "100%",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    transition: "transform 0.2s",
                  },
                }}
                onClick={() => navigate("/events")}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <EventIcon
                      sx={{ fontSize: 40, color: "primary.main", mr: 2 }}
                    />
                    <Typography variant="h6">Custom Event</Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    View your upcoming and past events, manage bookings
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card
                sx={{
                  height: "100%",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    transition: "transform 0.2s",
                  },
                }}
                onClick={() => navigate(`/profile/${currentUser?.user_id}`)}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <PersonIcon
                      sx={{ fontSize: 40, color: "primary.main", mr: 2 }}
                    />
                    <Typography variant="h6">Asset Library</Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    View and manage your profile settings, history, and
                    preferences
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default HomeBrand;
